import {
    type Element,
    type SlateEditor,
} from '@udecode/plate';

import { BaseFigureCaptionPlugin } from '../FigureCaptionBasePlugin';

export const isBelow = (
    editor: SlateEditor,
    currentElement: Element
): boolean => {
    const pathBefore = editor.api.after(currentElement);

    const entry = editor.api.block({
        at: pathBefore,
    });

    return !!(entry && entry[0].type === editor.getType(BaseFigureCaptionPlugin));
};
